<template minapp='mpx' xlang='wxml'>
  <view class="es-add-button__add">
    <es-button 
      block
      custom-class="es-add-button__add-btn"
      disabled="{{disabled}}"
      bind:click="handleClick"
    >
      <view class="es-add-button__add-btn-text">
        <image class="es-add-button__add-btn-icon" src="https://ut-static.udache.com/webx/sfc/fA9jGStTWK7w5yd2a6Q_s_clipboard_image_1699414509016.png"></image>
        <text>{{text}}</text>
      </view>
    </es-button>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    componentName: 'addButton',
    props: {
      text: {
        type: String,
        value: ''
      },
      disabled: {
        type: Boolean,
        value: false
      }
    },
    methods: {
      handleClick() {
        this.$trigger('click');
      }
    }
  })
</script>

<style lang='stylus' scoped>
  +b('add-button')
    +e('add')
      /deep/ .es-button--disabled
        color #ffffff !important 
        background-color #cccccc !important
        opacity 1 !important

    +e('add-btn')
      color #FF6400 !important
      border-radius 8px !important
      border none !important
      height 48px !important

    +e('add-btn-text')
      display flex
      font-weight 500
      align-items center
      font-size 14px

    +e('add-btn-icon')
      width 15px
      height 15px
      margin-right 4px
  
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-icon': '@didi/es-mpx-ui/lib/icon',
    }
  }
</script>

